import type { RouteObject } from 'react-router';
import { AdminLayout } from './AdminLayout';
import { SettingsHome } from './SettingsHome';
import { AssemblyPage, CarriersPage, ShopsPage, WarehousesPage } from './ResourcePages';
import { UsersPage } from './UsersPage';
import { RoleDetailPage } from './RoleDetail';
import { RoleComparePage } from './RoleCompare';
import { RolePermissionHistoryPage } from './RolePermissionHistory';
import { RoleMigrationPreviewPage } from './RoleMigrationPreview';
import { AccountDetailPage } from './AccountDetail';
import { AuditLogsPage } from './AuditLogsPage';
import { ImportsPage } from './ImportsPage';

/**
 * 系统设置 / 账号权限 / 审计（path 相对 /v2）。
 * 外层是无 path 的布局路由：桌面 / iPad 在 rail 右侧加一条设置侧栏，手机直接渲染页面。
 * 接法：放进 router.tsx 里 AppShell 的 children（与 orders 同级）。
 */
export const routes: RouteObject[] = [
  {
    element: <AdminLayout />,
    children: [
      { path: 'settings', element: <SettingsHome /> },
      { path: 'settings/assembly', element: <AssemblyPage /> },
      { path: 'settings/carriers', element: <CarriersPage /> },
      { path: 'settings/shops', element: <ShopsPage /> },
      { path: 'settings/warehouses', element: <WarehousesPage /> },
      { path: 'users', element: <UsersPage /> },
      { path: 'users/compare', element: <RoleComparePage /> },
      { path: 'users/history', element: <RolePermissionHistoryPage /> },
      { path: 'users/migration-preview', element: <RoleMigrationPreviewPage /> },
      { path: 'users/roles/:id', element: <RoleDetailPage /> },
      { path: 'users/accounts/:id', element: <AccountDetailPage /> },
      { path: 'audit-logs', element: <AuditLogsPage /> },
      { path: 'imports', element: <ImportsPage /> },
    ],
  },
];
